<template>
    <form @submit.prevent="submitForm" v-if="!isSend">
        <div class="form-field w-100">
            <input
                v-model="contact.name"
                name="fullName"
                type="text"
                id="fullName"
                placeholder=""
                autocomplete="name"
                required
                :class="emptyField( contact.name )"
            >
            <label for="fullName">Name<sup>*</sup></label>
        </div>

        <div class="form-field w-100">
            <input
                v-model="contact.email"
                name="email"
                type="email"
                id="email"
                autocomplete="email"
                placeholder=""
                required
                :class="emptyField( contact.email )"
            >
            <label for="email">Email<sup>*</sup></label>
        </div>
        <div class="form-field w-100">
            <textarea
                v-model="contact.message"
                name="message"
                id="message"
                placeholder=""
                rows="5"
                required
                :class="emptyField( contact.message )"
            ></textarea>
            <label for="email">Message<sup>*</sup></label>
        </div>
        <button
            :class="[
                'btn',
                'btn--primary',
                'btn--large',
                'btn--large-none',
                'btn--full',
                'btn--loader',
            ]"
            :disabled="isLoading"
            type="submit"
        >Send Message</button>
    </form>
    <div class="success-send" v-else>
        <p>Dear {{ contact.name }},</p>
        <p>Thank you for contacting our support team.</p>
        <p>
            We have successfully received and registered your support request. Our specialists are reviewing
            your inquiry and will provide a detailed response as soon as possible.
        </p>
        <p>Estimated response time: within 24 business hours.</p>
        <p>We appreciate your patience and will keep you informed about the progress of your request.</p>

        <p>
            Best regards,<br />
            Support Team
        </p>
    </div>
</template>

<script>

import { defineComponent } from 'vue'

export default defineComponent({
    name: "Contact",
    data() {
        return {
            isOpen: false, // до загрузки страницы показываем скелет или loading
            isLoading: false, // защита от множественных запросов
            isSend: false, // форма успешно отправлена
            images_url: '/templates/BinaryFlow/assets/images',
            contact: {
                name: '',
                email: '',
                message: '',
                recaptcha: '',
            },
        }
    },
    computed: {
        domain() {
            return window.location.hostname.replace('www', '')
        }
    },
    methods: {

        emptyField( field ) {
            const v = field.trim();
            return v !== '' ? 'filled' : 'empty';
        },

        /**
         * Отправка формы
         */
        async submitForm() {

            if( this.isLoading )
                return;

            this.isLoading = true

            try {
                const response = await this.$http.post('/ref/contact', this.contact)

                // Достаём данные из ответа
                const { status, code, data } = response.data;
                const message = data?.message;

                // Показываем уведомление, если есть сообщение
                if (message) {
                    // Динамический вызов по статусу с fallback на 'info'
                    const alertMethod = this.$alert[ status ];
                    if( typeof alertMethod === 'function' ) {
                        alertMethod( message );
                    } else {
                        this.$alert.info( message );
                    }
                }

                // Дополнительная логика по статусу success
                if( status === 'success' ) {
                    this.isSend = true;
                } else if (status === 'error' && code === 404) {
                    console.warn('Source not found');
                }

            } catch (err) {
                console.error('error: ', err)
            } finally {
                this.isLoading = false
            }
        },
    }
});
</script>

<style scoped>

</style>